import BaseComponent from '@/components/base';
import Style from '@/components/product-extra-details/style';
import 'slick-carousel';

export default class ProductExtraDetails extends BaseComponent {
  get extraDetailsElement() {
    return this.shadowRoot.querySelector('.product-extra-details');
  }

  afterMount() {
    this.navContainer = this.extraDetailsElement.querySelector('.navigation');
    this.navBlocks = this.navContainer.querySelectorAll('.nav-title');
    this.navBlocksNumber = this.navBlocks.length;
    this.contentTabs =
      this.extraDetailsElement.querySelectorAll('.content-tab');
    this.slider = this.extraDetailsElement.querySelectorAll(
      '.image-container.slick'
    );
    this.setupSliders();
  }

  setupSliders() {
    if (this.slider.length > 0) {
      if (!this.slider.classList.contains('slick-initialized')) {
        this.slider.slick({
          dots: false,
          infinite: false,
          speed: 600,
          slidesToShow: 1,
          arrows: false,
          mobileFirst: true,
          responsive: [
            {
              settings: {
                arrows: true
              }
            }
          ]
        });
      }
    }

    this.navBlocks.forEach((block) => {
      block.addEventListener('click', this.matchTabs.bind(this));
    });
  }

  matchTabs(e) {
    let activeNumber = 0;

    for (let i = 0; i < this.navBlocksNumber; i++) {
      document.querySelector(`.nav-title-${i}`)?.classList.remove('active');
      if (e.currentTarget.classList.contains(`nav-title-${i}`)) {
        activeNumber = i;
        e.currentTarget.classList.add('active');
      }
    }

    this.contentTabs.forEach((tab) => {
      tab.classList.add('hidden');
      if (tab.classList.contains(`content-tab-${activeNumber}`)) {
        tab.classList.remove('hidden');
      }
    });
  }

  get details() {
    return this.data.details.value;
  }

  render() {
    return `
    ${Style}

    <div class="product-extra-details">
      <div class="section-content">
        <div class="details-container accordion-container tab-accordion-system keep-tabs-opened">
          <div class="navigation-wrapper">
            <div class="navigation">
              ${this.details
                .map(
                  (content, index) => `
                    <a class="title-font-9 nav-title nav-title-${index} ${
                      index === 0 ? 'active' : ''
                    }" data-index="${index}">
                      ${content.tab_title}
                    </a>
                  `
                )
                .join('')}
            </div>
          </div>

          ${this.details
            .map((content, index) => {
              const imageCount = content.images.length;
              const showSlider = imageCount > 1 || content.video_url;
              const tabTitle = content.tab_title.toLowerCase();

              return `
                <div class="system content-tab content-tab-${index} ${
                  index !== 0 ? 'hidden' : ''
                }">
                  <div class="system-title title-font-9 system-title-${index}" data-target="system-${index}">
                    ${content.tab_title}
                  </div>
                  <div class="system-content" data-target="system-${index}">
                    <div class="content-inner">
                      ${
                        imageCount > 0 || content.video_url
                          ? `
                        <div class="image-container ${
                          showSlider ? 'slick' : ''
                        }">
                          ${content.images
                            .map(
                              (image) => `
                            <img src="${image}" alt="">
                          `
                            )
                            .join('')}
                          ${
                            content.video_url
                              ? `
                            <div class="video-wrapper"
                                 data-video-type=""
                                 data-video-id=""
                                 data-video-src="${content.video_url}">
                              <div class="content-wrapper">
                                <button class="video-ctl paused"></button>
                              </div>
                            </div>
                          `
                              : ''
                          }
                        </div>
                      `
                          : ''
                      }

                      <div class="text-image-content">
                        ${content.text_content
                          .map(
                            (textContent) => `
                              <div class="block${
                                tabTitle === 'faqs' ? ' faqs' : ''
                              }">
                                <div class="text-only">
                                  ${
                                    textContent.headline
                                      ? `<p class="title-font-9 headline">${textContent.headline}</p>`
                                      : ''
                                  }
                                  ${
                                    textContent.subheadline
                                      ? `<p class="subheadline ${
                                          textContent.headline
                                            ? 'body-font-1'
                                            : 'title-font-11'
                                        }">${textContent.subheadline}</p>`
                                      : ''
                                  }
                                </div>
                              </div>
                            `
                          )
                          .join('')}
                        ${
                          content.cta_text
                            ? `<a href="${content.cta_url}" class="cta cta-1">${content.cta_text}</a>`
                            : ''
                        }
                      </div>
                    </div>
                  </div>
                </div>
              `;
            })
            .join('')}
        </div>
      </div>
    </div>
  `;
  }
}
